
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    appVersion: { type: String, default: undefined }
  },
  setup() {
    return {
      currentYear: new Date().getFullYear()
    }
  }
})
